import { MicrositeModule } from 'utils/i18n/TModules';

export const MicrositePageKey = `MicrositePage`;
export const TMicrositePage = `${MicrositeModule}:${MicrositePageKey}`;
export const TabsKey = `Tabs`;
export const BrandingKey = `Branding`;
export const BuilderKey = `Builder`;
export const PublishKey = `Publish`;
export const PreviewKey = `Preview`;
export const ControlKey = `Control`;
export const GuardKey = `Guard`;

export const TMicrositeTabs = `${MicrositeModule}:${TabsKey}`;
export const TMicrositeBranding = `${MicrositeModule}:${BrandingKey}`;
export const TMicrositeBuilder = `${MicrositeModule}:${BuilderKey}`;
export const TMicrositePublish = `${MicrositeModule}:${PublishKey}`;
export const TMicrositePreview = `${MicrositeModule}:${PreviewKey}`;
export const TMicrositeControl = `${MicrositeModule}:${ControlKey}`;
export const TMicrositeGuard = `${MicrositeModule}:${GuardKey}`;
